import { connect } from 'react-redux';
import branch from 'recompose/branch';
import withHandlers from 'recompose/withHandlers';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import withCardCharge from '../hoc/withCardCharge';
import { getHasCard } from '../reducer/card/selectors';
import CardInput from '../components/CardInput';
import { setCard } from '../reducer/card/actions';
import withCreatePaymentCard from '../../../common/hoc/withCreatePaymentCard';
import { getCustomerId, getHasCustomerCard } from '../../customer/selectors';

const onToken = props => async (response) => {
  let id;
  if (props.customerId) {
    const customerCard = await props.createPaymentCard(props.customerId, response.id);
    id = customerCard.id;
  }
  const card = { ...response.card, paymentToken: response.id, id };
  return props.cardCharge(card).then(() => {
    props.setCard(card);
    if (props.onToken) {
      props.onToken(response);
    }
  });
};

const CardInputContainer = compose(
  withCardCharge,
  withCreatePaymentCard,
  connect(
    state => ({
      hasCard: getHasCustomerCard(state) || getHasCard(state),
      customerId: getCustomerId(state),
    }),
    { setCard }
  ),
  withHandlers({
    onSubmit: props => createToken => (e) => {
      e.preventDefault();
      createToken(onToken(props));
    },
  }),
  branch(props => props.hasCard, renderNothing)
)(CardInput);

export default CardInputContainer;
